/* lystia-home-bestsellers.js - Головна · «Бестселери» (T-E6-05; prototype home.js bestsellers()).
   <lystia-home-bestsellers data-section-id>: чіпи [data-best-chip][data-url]; порожній data-url = «Усі» (початкова сітка з сервера).
   Перемикання = Section Rendering: GET <data-url>?section_id=<id секції> -> сітка [data-best-grid].
   Анімація (як у прототипі): якщо !reducedMotion - host opacity 0 -> через 140 мс заміна сітки і opacity 1 (перехід у CSS .14s); інакше миттєво. */
(function () {
  'use strict';
  if (customElements.get('lystia-home-bestsellers')) return;

  var FADE_MS = 140;

  class LystiaHomeBestsellers extends HTMLElement {
    connectedCallback() {
      this.host = this.querySelector('[data-best-host]');
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-best-chip]'));
      if (!this.host || !this.chips.length) return;
      this.cache = {};
      this.token = 0;
      var first = this.host.querySelector('[data-best-grid]');
      if (first) this.cache[''] = first;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      clearTimeout(this.timer);
    }

    onClick(e) {
      var chip = e.target.closest && e.target.closest('[data-best-chip]');
      if (!chip || !this.contains(chip)) return;
      if (chip.classList.contains('is-active')) return;
      var prev = this.chips.filter(function (c) { return c.classList.contains('is-active'); })[0];
      this.setActive(chip);
      this.show(chip.getAttribute('data-url') || '', prev);
    }

    setActive(chip) {
      this.chips.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    load(url) {
      var self = this;
      if (this.cache[url]) return Promise.resolve(this.cache[url]);
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + sep + 'section_id=' + encodeURIComponent(this.getAttribute('data-section-id')), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('[data-best-grid]');
          if (!grid) throw new Error('no grid');
          self.cache[url] = grid;
          return grid;
        });
    }

    show(url, prevChip) {
      var self = this;
      var token = ++this.token;
      var animate = !(document.lystia && document.lystia.reducedMotion());
      clearTimeout(this.timer);
      var wait = new Promise(function (res) {
        if (animate) {
          self.host.style.opacity = '0';
          self.timer = setTimeout(res, FADE_MS);
        } else res();
      });
      Promise.all([this.load(url), wait]).then(function (r) {
        if (token !== self.token) return;
        self.host.replaceChildren(r[0].cloneNode(true));
        self.host.style.opacity = '1';
        if (window.LystiaFavorites && window.LystiaFavorites.syncAll) window.LystiaFavorites.syncAll();
      }).catch(function () {
        if (token !== self.token) return;
        self.host.style.opacity = '1';
        if (prevChip) {
          self.setActive(prevChip);
        }
      });
    }
  }

  customElements.define('lystia-home-bestsellers', LystiaHomeBestsellers);
})();
